export const reactivityKeys = {
  authToken: 'authToken',
  orderToken: 'orderToken',
  orderShipment: 'orderShipment',
  alertMessagesDismissed: 'alertMessagesDismissed',
  productsComparison: 'productsComparison',
  customer: 'customer',
  favouriteLists: 'favouriteLists',
  favouriteListProducts: 'favouriteListProducts',
};

/**
 * Generates granular reactive keys for product filters to improve performance
 * by only triggering updates for the specific filter that changed.
 */
export const createProductFilterReactivityKey = {
  /**
   * Creates a reactive key for a specific checkbox filter
   * @param attributeCode The attribute code for the filter
   * @returns Reactive key string
   */
  checkbox: (attributeCode: string) => `productFilters:checkbox:${attributeCode}`,
  checkboxes: () => `productFilters:checkbox`,

  /**
   * Creates a reactive key for a specific range filter
   * @param attributeCode The attribute code for the filter
   * @returns Reactive key string
   */
  range: (attributeCode: string) => `productFilters:range:${attributeCode}`,
  ranges: () => `productFilters:range`,

  /**
   * Creates a reactive key for a specific text filter
   * @param attributeCode The attribute code for the filter
   * @returns Reactive key string
   */
  text: (attributeCode: string) => `productFilters:text:${attributeCode}`,
  texts: () => `productFilters:text`,

  /**
   * Creates a reactive key for brand filters
   * @returns Reactive key string
   */
  brand: () => `productFilters:brand`,
  brands: () => `productFilters:brands`,

  /**
   * Creates a reactive key for warehouse filters
   * @returns Reactive key string
   */
  warehouse: () => `productFilters:warehouse`,
  warehouses: () => `productFilters:warehouses`,

  /**
   * Creates a reactive key for taxon filters
   * @returns Reactive key string
   */
  taxon: () => `productFilters:taxon`,
  taxons: () => `productFilters:taxons`,

  /**
   * Creates a reactive key for all filters combined
   * @returns Reactive key string
   */
  all: () => 'productFilters',
};
